<script setup>
import {onMounted, onUnmounted, reactive, ref} from 'vue';
import mapboxgl from "mapbox-gl";
import {ApiWrapper} from "@/Utils/ApiWrapper";
import {activeComponentStore} from "@/Stores/ActiveComponentStore";
import {Permissions} from "@/Utils/Permissions";
import '@mdi/font/css/materialdesignicons.css'

import 'vue-json-pretty/lib/styles.css';
import ClaimRawDataComponent from "@/Components/ClaimInfo/ClaimRawDataComponent.vue";
import {ToastUtil} from "@/Utils/ToastUtil";
import {DateUtil} from "@/Utils/DateUtil";

import PDFDocument from '@/StandaloneJS/pdfkit.standalone'
import blobStream from "blob-stream";
const compName = 'ClaimInfoComponent';

const props = defineProps({
  contextSchemaA: String,
  contextIdA: String
});

const form = ref(null);

const data = reactive({
  viewRawData: 'closed',
  absolute: true,
  ackSent: null,
  claimTypes: ['Fire', 'Flood', 'Hail', 'Hurricane', 'Liability', 'Water', 'Wind', 'Other'],
  clientInfo: [],
  dialog2: false,
  dialog: false,
  edit: false,
  items: {additionalinfo: '', type: ''},
  itemsPDF: [],
  loading: false,
  menu1: false,
  closeDOL: false,
  newItem: [],
  newLossAmount: null,
  newState: null,
  opacity: .1,
  open: false,
  overlay: false,
  previous: false,
  priority: false,
  reasons: [
    'Agreed Price',
    'Agreed Scope',
    'Fix Invoice',
    'Reinspect - Hidden Damage',
    'PA Involved',
    'Other'
  ],
  states: [
    'AL',
    'AK',
    'AS',
    'AZ',
    'AR',
    'CA',
    'CO',
    'CT',
    'DE',
    'DC',
    'FM',
    'FL',
    'GA',
    'GU',
    'HI',
    'ID',
    'IL',
    'IN',
    'IA',
    'KS',
    'KY',
    'LA',
    'ME',
    'MH',
    'MD',
    'MA',
    'MI',
    'MN',
    'MS',
    'MO',
    'MT',
    'NE',
    'NV',
    'NH',
    'NJ',
    'NM',
    'NY',
    'NC',
    'ND',
    'MP',
    'OH',
    'OK',
    'OR',
    'PW',
    'PA',
    'PR',
    'RI',
    'SC',
    'SD',
    'TN',
    'TX',
    'UT',
    'VT',
    'VI',
    'VA',
    'WA',
    'WV',
    'WI',
    'WY',
  ],
  show: false,
  valid: true,
});

const a = document.createElement('a')
document.body.appendChild(a)
a.style = "display: none";

const getDataPDF = () => {
  data.loading = true
  // let contextId = new URLSearchParams(window.location.search).get(
  //     'contextIdA'
  // )
  ApiWrapper.post('claim-info', 'claim-info',{},'claimId='+props.contextIdA)
      .then((response) => {
        data.itemsPDFinsuredperson = response.dataPDFinsuredperson
        data.itemsPDFclientcontacts = response.dataPDFclientcontacts
        data.itemsPDFClaimClient = response.dataPDFClaimClient
        if (data.itemsPDFClaimClient.type !== null) {
          data.itemsPDFClaimClient.type = data.itemsPDFClaimClient.type.split(', ');
        }
        else{
          data.itemsPDFClaimClient.type = [''];
        }
        data.itemsPDFClaimClient.lossdate = DateUtil.formatDate(data.itemsPDFClaimClient.lossdate);
        data.itemsPDF.push(data.itemsPDFinsuredperson)
        data.itemsPDF.push(data.itemsPDFclientcontacts)
        data.itemsPDF.push(data.itemsPDFClaimClient)
        data.itemsPDF.push(response.dataPDFadmin)
        data.itemsPDF.push(response.dataPDFnote)
        download(data.itemsPDF);
        data.loading = false
        // ToastUtil.successMsg('Acknowledgement sent');
      })
      .catch((e)=>{
        ToastUtil.error(e);
        data.loading = false;
      })
}

const formatTimestampByLocale = (timestamp) => {
  const date = new Date(timestamp)
  const timeOptions = {
    hour12: true,
    hour: "numeric",
    minute: "2-digit",
  }
  const dateOptions = {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    timeZoneName:'short'
  }
  return date.toLocaleString('en', { ...dateOptions, ...timeOptions })
}

const download = (item) => {
  let doc = new PDFDocument({ margin: 25 })
  let stream = doc.pipe(blobStream())

  let c = document.createElement('canvas');
  let img = document.getElementById('tux');
  c.height = img.naturalHeight;
  c.width = img.naturalWidth;
  let ctx = c.getContext('2d');

  function stripHtml(html)  {
    let tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  }

  ctx.drawImage(img, 0, 0, c.width, c.height);
  let base64String = c.toDataURL();
  doc.image(base64String, 25, 10, {width: 150})
  doc
      .font('Helvetica')
      .fontSize(8)
      .text('Associated Adjusting', { align: 'right' }, 25)
  doc
      .font('Helvetica')
      .fontSize(8)
      .text('141 Quaker Way', { align: 'right' })
  doc
      .font('Helvetica')
      .fontSize(8)
      .text('Knoxville TN,', { align: 'right' })
  doc
      .font('Helvetica')
      .fontSize(8)
      .text('37920', { align: 'right' })

  doc
      .font('Helvetica')
      .fontSize(16)
      .text(`Claim Information`, {align: 'center'}, 30)


  doc.moveTo(5, 70).lineTo(607, 70).stroke()

  doc.moveDown()

  // **** Claim Info ****
  doc.font('Helvetica').fontSize(8).text('Claim Number: ', 10, 80)
  doc.font('Helvetica-Bold').fontSize(16).text(item[2].claimnumber, 10, 90)

  doc.font('Helvetica').fontSize(8).text('Loss Amount: ', 10, 110)
  doc.font('Helvetica').fontSize(10).text(item[2].lossamount, 10, 120)

  doc.font('Helvetica').fontSize(8).text('Loss Date: ', 10, 135)
  doc.font('Helvetica').fontSize(10).text(item[2].lossdate, 10, 145)

  doc.font('Helvetica').fontSize(8).text('Policy Number: ', 10, 160)
  doc.font('Helvetica').fontSize(10).text(item[2].policynumber, 10, 170)

  doc.font('Helvetica').fontSize(8).text('Loss Address: ', 10, 185)
  doc.font('Helvetica').fontSize(10).text(item[2].streetaddress, 10, 195)
  doc.font('Helvetica').fontSize(10).text((item[2].city === null ? '' : item[2].city) + ', ' + (item[2].state === null ? '' : item[2].state) + ' ' + (item[2].zip === null ? '' : item[2].zip), 10, 205)
  doc.font('Helvetica').fontSize(8).text('Type: ', 10, 220)
  doc.font('Helvetica').fontSize(10).text(`${item[2].type[0] ? item[2].type[0] : ''} ${item[2].type[1] ? item[2].type[1] : ''} ${item[2].type[2] ? item[2].type[2] : ''} ${item[2].type[3] ? item[2].type[3] : ''} ${item[2].type[4] ? item[2].type[4] : ''} ${item[2].type[5] ? item[2].type[5] : ''} ${item[2].type[6] ? item[2].type[6] : ''}`, 10, 230)


  doc.font('Helvetica').fontSize(8).text('Cat Code: ', 10, 245)
  if(item[2].catcode) {
    doc.font('Helvetica').fontSize(10).text(item[2].catcode, 10, 255)
  } else {
    doc.font('Helvetica').fontSize(10).text('N/A', 10, 255)
  }

  // **** Additional Info ****
  doc.font('Helvetica').fontSize(8).text('Additional Info: ', 10, 270)
  doc.font('Helvetica').fontSize(10).text(item[2].additionalinfo, {
    width: 220,
  })

  doc.moveDown()
  doc.font('Helvetica').fontSize(8).text('Client: ', 10)
  doc.font('Helvetica-Bold').fontSize(16).text(item[2].clientname, {
    width: 220,
  })

  // **** Client Contacts ****
  if (item[1].length > 0) {
    doc.moveDown();
    doc.font('Helvetica').fontSize(8).text(`Client Contacts: `, 10)

    for (let x in item[1]) {
      let person = item[1][x]

      if (person.role) {
        doc.font('Helvetica').fontSize(10).text(person.role, 10)
      }
      doc.font('Helvetica').fontSize(10).text(person.insuredname, 10)
      if (person.homephone) {
        doc.font('Helvetica').fontSize(10).text('Home: ' + person.homephone, 10)
      }
      if (person.cellphone) {
        doc.font('Helvetica').fontSize(10).text('Cell: ' + person.cellphone, 10)
      }
      if (person.workphone) {
        doc.font('Helvetica').fontSize(10).text('Work: ' + person.workphone, 10)
      }

      doc.moveDown();
    }
  }

  // **** Client Message ****
  doc.moveDown();
  doc.font('Helvetica').fontSize(8).text('Client Message: ', 10)
  doc.font('Helvetica').fontSize(10).text(item[2].clientmessage, {
    width: 220,
  })

  doc.moveDown()

  // **** Claim Contacts ****
  if (item[0].length > 0) {

    doc.font('Helvetica').fontSize(8).text(`Claim Contacts: `, 250, 80)

    doc.moveDown()

    for (let x in item[0]) {
      let person = item[0][x]

      if (person.metadata.type) {
        doc.font('Helvetica').fontSize(10).text(`${person.metadata.type}`, 250)
      } else {
        doc.font('Helvetica').fontSize(10).text('N/A', 250)
      }
      if (person.metadata.type === 'Insured Person') {
        doc.font('Helvetica-Bold').fontSize(16).text(person.insuredname, {
          width: 175,
        })
      } else {
        doc.font('Helvetica').fontSize(10).text(person.insuredname, {
          width: 175,
        })
      }
      if (person.streetaddress) {
        doc.font('Helvetica').fontSize(10).text(person.streetaddress, 250)
        doc.font('Helvetica').fontSize(10).text(`${person.city ? person.city : ' '} ${person.state ? person.state : ' '} ${person.zip ? person.zip : ' '}`, 250)
      } else {
        doc.font('Helvetica').fontSize(10).text('N/A', 250)
      }
      if (person.homephone) {
        doc.font('Helvetica').fontSize(10).text('Home: ' + person.homephone, 250)
      }
      if (person.cellphone) {
        doc.font('Helvetica').fontSize(10).text('Cell: ' + person.cellphone, 250)
      }
      if (person.workphone) {
        doc.font('Helvetica').fontSize(10).text('Work: ' + person.workphone, 250)
      }

      doc.moveDown();
    }
  }

  const claimContactsY = doc.y

  // **** Admins ****
  if (item[3].length > 0) {

    doc.font('Helvetica').fontSize(8).text(`Admins: `, 450, 80)

    doc.moveDown()

    for (let x in item[3]) {
      let person = item[3][x]

      doc.font('Helvetica').fontSize(10).text(`${person.role}`, 450)
      doc.font('Helvetica').fontSize(10).text(person.name, 450)
      if(person.homephone){
        doc.font('Helvetica').fontSize(10).text('Home: ' + person.homephone, 450)
      }
      if(person.mobilephone){
        doc.font('Helvetica').fontSize(10).text('Cell: ' + person.mobilephone, 450)
      }
      if(person.workphone){
        doc.font('Helvetica').fontSize(10).text('Work: ' + person.workphone, 450)
      }

      doc.moveDown();
    }
  }

  const adminsY = doc.y

  let notesStartY = adminsY > claimContactsY ? adminsY : claimContactsY

  // Notes
  if (item[4].length > 0) {
    doc.font('Helvetica').fontSize(8).text(`Notes: `, 250, notesStartY)
    doc.moveDown();
    for (let x in item[4]) {
      let notesPDF = item[4][x]
      doc.font('Helvetica').fontSize(10).text(notesPDF.name + ' created a note - ' + formatTimestampByLocale(notesPDF.created_at))
      doc.moveDown();
      doc
          .font('Helvetica')
          .fontSize(8)
          .text('Note:')
      doc
          .font('Helvetica')
          .fontSize(10)
          .text(stripHtml(notesPDF.note))
      doc.moveDown();

      if (typeof notesPDF.additionalinfo === 'string' && notesPDF.additionalinfo.length > 0 && notesPDF.additionalinfo != null) {
        // Removes formatting for additionalinfo
        let addInfo = notesPDF.additionalinfo;

        addInfo = addInfo.replace(/nbsp;/g, '');
        addInfo = addInfo.replace(/amp;nbsp;/g, '');
        addInfo = addInfo.replace(/amp;ndash;/g, '');
        addInfo = addInfo.replace(/amp;gt;/g, '');
        addInfo = addInfo.replace(/amp;lt;/g, '');
        addInfo = addInfo.replace(/gt;/g, '');
        addInfo = addInfo.replace(/lt;/g, '');
        addInfo = addInfo.replace(/ndash;/g, '');
        addInfo = addInfo.replace(/\\n/g, '');
        addInfo = addInfo.replace(/ \n/g, '');
        addInfo = addInfo.replace(/(\r\n|\n|\r)/gm,"");
        addInfo = addInfo.replace(/\s\s+/g, ' ');
        addInfo = addInfo.trim();

        notesPDF.additionalinfo = addInfo

        doc
            .font('Helvetica')
            .fontSize(8)
            .text('Additional Info:')

        doc
            .font('Helvetica')
            .fontSize(10)
            .text(stripHtml(notesPDF.additionalinfo))
        doc.moveDown()
      }
      if(x != item[4].length - 1){
        doc
            .moveTo(250, doc.y + 5)
            .lineTo(487, doc.y + 5)
            .stroke()
        doc.moveDown()
      }
      doc.moveDown();
    }
  }

  doc.end()

  let blob
  stream.on('finish', function () {
    blob = stream.toBlob('application/pdf')
    if (!blob) return
    let url = window.URL.createObjectURL(blob)
    a.href = url
    a.download = item[2].claimnumber
    a.click()
    window.URL.revokeObjectURL(url)
  })
}

const sendEmail = async() => {
  data.loading = true;
  await ApiWrapper.post('claim-info', 'send-acknowledgement', {
        claimId: data.items.id
      })
      .then((response) => {
        getData();
      })
      .catch((err) => {
        ToastUtil.error(err);
        data.loading = false;
      })
}

const setPriority = async() => {
  data.loading = true;
  await ApiWrapper.post('claim-info', 'set-priority', {
        priority: data.priority,
        claimId: data.items.id
      })
      .then((response) => {
        getData()
        ToastUtil.successMsg('Updated claim priority');
      })
      .catch((err) => {
        ToastUtil.error(err);
        data.loading = false;
      })
}

const changeStatus = async() => {
  if (data.items.isclosed === false || form.value.validate()) {
    data.dialog = false
    data.dialog2 = false
    if(data.newItem.isclosed === true) {
      data.newItem.isclosed = false
    } else {
      data.newItem.isclosed = true
    }
    await ApiWrapper.post('claim-info', 'change-status',  {
          newStatus: data.newItem.isclosed,
          claimId: data.items.id
        })
        .then((response) => {
          getData()
          activeComponentStore.notifyComponents(['claimstatusupdate'],compName);

          ToastUtil.successMsg(data.newItem.isclosed ? 'Closed claim' : 'Reopened claim');
        })
        .catch((err) => {
          ToastUtil.error(err);
          data.loading = false;
        })
  }
}

const cancel = () => {
  data.edit = false
  getData()
  data.newItem = data.items
}

const parseDateWithoutTZ = (dateStr) => {
  if (!dateStr) return null;

  let year, month, day;

  if(dateStr.includes('-')) {
    [year, month, day] = dateStr.split('-').map(Number);
  }
  else {
    [month, day, year] = dateStr.split('/').map(Number);
  }

  return new Date(year, month - 1, day);
}

const displayDate = (dateStr) => {
  const date = parseDateWithoutTZ(dateStr);

  return date ? date.toLocaleDateString() : null;
}

const getData = async() => {
  data.loading = true
  await ApiWrapper.post('claim-info','claim-info',{}, 'claimId='+props.contextIdA )
      .then((response) => {
        if(response.ack === true){
          data.ackSent = true
        }else{
          data.ackSent = false
        }
        data.clientInfo = response.dataClientInfo
        if(response.additionalinfo === null || response.additionalinfo === undefined){
          response.additionalinfo = ''
        }
        if(response.type === null){
          response.type = ''
        }
        data.items = response.data

        data.previous = response.previous
        if(data.items.isclosed === true){
          data.items.claimstatus = 'Closed'
          data.overlay = true
        } else {
          data.items.claimstatus = 'Open'
          data.overlay = false
        }
        data.newItem = response.data
        if (data.newItem.type) {
          data.newItem.type = data.newItem.type.split(', ')
        }
        data.newItem.lossdate = DateUtil.formatDate(data.newItem.lossdate);
        data.priority = response.priority

        data.edit = false

      }).catch((e)=>{
        ToastUtil.error(e);
      })
      .finally(()=>{
        data.loading = false
      });
}

const submit = async() => {
  data.loading = true

  if(data.newItem.streetaddress === null){
    data.newItem.streetaddress = ''
  }

  let encodedSearch = encodeURI(
      (data.newItem?.streetaddress ? data.newItem.streetaddress.replaceAll('#', '') : '') +
      `, ` +
      data.newItem.city +
      `, ` +
      data.newItem.state +
      ` ` +
      data.newItem.zip
  )
  await ApiWrapper.getRaw(
      'https://api.mapbox.com/geocoding/v5/mapbox.places/' +
        encodedSearch +
        '.json?access_token=pk.eyJ1IjoiZW50cmVvcyIsImEiOiJja2RydG16MXEwZ3hvMnhuOXVlcHZhcWRvIn0.mlZA3MAQSFupaQbmFjA9QQ'
  )
  .then(async function (response) {
    if (response.features.length === 0) {
      ToastUtil.errorMsg('No location found for that address')
    }
    else {
      data.newItem.longitude = response.features[0].center[0].toString()
      data.newItem.latitude = response.features[0].center[1].toString()
       let claimTypeString = ''
      if (data.newItem.type) {
        for ( let x = 0; x < data.newItem.type.length; x++) {
          claimTypeString += data.newItem.type[x]
          claimTypeString += ', '
        }
      }
      data.newItem.lossamount = (data.newItem?.lossamount ? data.newItem.lossamount.replaceAll('$','').replaceAll(',','') : '');

      await ApiWrapper.post('claim-info', 'edit',  {
            newClaimNumber: data.newItem.claimnumber,
            newState: data.newItem.state,
            newCity: data.newItem.city,
            newStreet: data.newItem.streetaddress,
            newZip: data.newItem.zip,
            lossAmount: parseFloat(data.newItem.lossamount),
            newPolicyNumber: data.newItem.policynumber,
            newLossDate: data.newItem.lossdate,
            newCatCode: data.newItem.catcode,
            newType: claimTypeString,
            newAdditionalInfo: data.newItem.additionalinfo,
            claimId: data.items.id,
            newLat: data.newItem.latitude,
            newLong: data.newItem.longitude,
            newStatus: data.newItem.isclosed
          })
          .then((response) => {
            getData();
            activeComponentStore.notifyComponents(['claims','updateTasks'],compName)

            ToastUtil.successMsg('Updated claim');
          })
          .catch((err) => {
            ToastUtil.error(err);
            data.loading = false;
          })
    }
  })
  .catch((err) => {
    ToastUtil.error(err);
    data.loading = false;
  })
}

onMounted(()=>{
  activeComponentStore.registerComponent(
      compName,
      [
        'claims',
        'person',
        'claimcontacts',
        'clientcontacts',
        'clients',
        'adjusters',
        'notes'
      ],
      getData
  );
  getData();
  mapboxgl.accessToken =
      'pk.eyJ1IjoiZW50cmVvcyIsImEiOiJja2RydG16MXEwZ3hvMnhuOXVlcHZhcWRvIn0.mlZA3MAQSFupaQbmFjA9QQ';
});

onUnmounted(() => {
  activeComponentStore.deregisterComponent(compName);
});

</script>

<template>
  <v-container fluid>
    <v-card class="elevation-2" height="auto" width="auto">
      <!-- The below alert is for Farmers Insurance (client id = 2) -->
      <v-alert
          v-if="data.previous && data.clientInfo.clientid === 2"
          type="info"
          variant="text"
          outlined
          density="compact"
          class="mb-0"
      >
        Previous Loss at Location
      </v-alert>
      <!-- *************************************************** -->
      <v-alert
          v-if="data.items.type?.toString().toLowerCase().includes('fire')"
          type="warning"
          icon="mdi-fire"
          density="compact"
      >
        FIRE LOSS
      </v-alert>
      <v-progress-linear
          :active="data.loading"
          :indeterminate="data.loading"
          absolute
          bottom
          color="primary"
      ></v-progress-linear>
      <v-form v-if="data.edit" class="pt-4">
        <v-text-field
            v-model="data.newItem.claimnumber"
            label="Claim Number"
            class="px-5"
        ></v-text-field>
        <v-text-field
            v-model="data.newItem.lossamount"
            label="Loss Amount"
            class="px-5"
        ></v-text-field>
        <v-menu
            ref="menu1"
            v-model="data.menu1"
            :close-on-content-click="data.closeDOL"
            transition="scale-transition"
            :return-value="data.newItem.lossdate"
            offset-y
            max-width="290px"
            min-width="auto"
        >
          <template v-slot:activator="{ on, props }">
            <v-text-field
                v-model="data.newItem.lossdate"
                label="Date of Loss"
                class="px-5"
                v-bind="props"
                v-on="on"
                clearable
                readonly
                @update:modelValue="data.date = parseDateWithoutTZ(data.newItem.lossdate)"
                @focus="data.closeDOL = false"
            ></v-text-field>
          </template>
          <v-date-picker
              v-model="data.date"
              no-title
              :show-current="true"
              @update:modelValue="data.date=$event; data.newItem.lossdate = DateUtil.formatDate(data.date); data.closeDOL = true"
          ></v-date-picker>
        </v-menu>
        <v-text-field
            v-model="data.newItem.streetaddress"
            label="Street Address"
            class="px-5"
        ></v-text-field>
        <v-text-field
            v-model="data.newItem.city"
            label="Claim City"
            class="px-5"
        ></v-text-field>
        <v-autocomplete
            v-model="data.newItem.state"
            :items="data.states"
            label="Claim State"
            class="px-5"
            auto-select-first
        ></v-autocomplete>
        <v-text-field
            v-model="data.newItem.zip"
            label="Claim Zip"
            class="px-5"
        ></v-text-field>
        <v-text-field
            v-model="data.newItem.policynumber"
            label="Policy Number"
            class="px-5"
        ></v-text-field>
        <v-text-field
            v-model="data.newItem.catcode"
            label="Cat Code"
            class="px-5"
        ></v-text-field>
        <v-autocomplete
            class="px-5"
            v-model="data.newItem.type"
            :items="data.claimTypes"
            label="Claim Type"
            auto-select-first
            multiple
        ></v-autocomplete>
        <v-textarea
            prepend-inner-icon="mdi-pencil"
            filled
            clearable
            clear-icon="mdi-close"
            label="Additional Info (Optional)"
            hint="No character limit"
            v-model="data.newItem.additionalinfo"
            class="px-5"
            auto-grow
        >
        </v-textarea>
        <v-card-actions>
          <v-btn size="small" variant="elevated" color="error" @click="cancel">Cancel</v-btn>
          <v-btn size="small" variant="elevated" color="primary" @click="submit">Submit</v-btn>
        </v-card-actions>
      </v-form>

      <div v-else class="pa-0 containerForClosedMain">
        <v-list-item density="compact" class="claim__number">
            <v-list-item-subtitle class="pb-0 pt-2">Claim Number</v-list-item-subtitle>
          <v-spacer></v-spacer>
        </v-list-item>
        <v-toolbar density="compact" flat color="white">
          <v-toolbar-title class="font-weight-bold">{{data.items.claimnumber}}</v-toolbar-title>
          <v-icon class="ml-2" color="primary" @click="getDataPDF"> mdi-file-pdf-box </v-icon>
          <v-spacer></v-spacer>
          <h4 class="mr-4">Age (Days): {{data.items.duration}}</h4>
          <!-- Close claim dialog button -->
          <v-dialog
              v-if="data.items.claimstatus === 'Open'"
              v-model="data.dialog"
              persistent
              max-width="290"
          >
            <template v-slot:activator="{ on, props }">
              <v-btn
                  color="success"
                  variant="elevated"
                  dark
                  size="small"
                  v-bind="props"
                  v-on="on"
              >
                Status: {{ data.items.claimstatus }}
                <v-icon
                    right
                    dark
                >
                  mdi-checkbox-marked-circle
                </v-icon>
              </v-btn>
            </template>
            <v-card>
              <v-card-title class="headline">
                Confirm that you wish to CLOSE this claim?
              </v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="error"
                    variant="text"
                    @click="data.dialog = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                    color="success"
                    v-if="Permissions.checkPermissions(['claims.close'])"
                    variant="text"
                    @click="changeStatus"
                >
                  Confirm
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!-- Open claim dialog button -->
          <v-dialog
              v-if="data.items.claimstatus === 'Closed'"
              v-model="data.dialog2"
              persistent
              max-width="290"
          >
            <template v-slot:activator="{ on, props }">
              <v-btn
                  v-if="data.items.claimstatus === 'Closed'"
                  class="error"
                  color="error"
                  size="small"
                  variant="elevated"
                  dark
                  v-bind="props"
                  v-on="on"
              >
                Status: {{ data.items.claimstatus }}
              </v-btn>
            </template>
            <v-card>
              <v-card-title class="headline">
                Reason for re-opening this claim?
              </v-card-title>
              <v-form
                  ref="form"
                  v-model="data.valid"
                  lazy-validation
              >
                <v-select
                    density="compact"
                    class="mx-6"
                    :items="data.reasons"
                    :rules="[v => !!v || 'Reason is required']"
                    label="Select Reason"
                    required
                ></v-select>
              </v-form>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="error"
                    variant="text"
                    @click="data.dialog2 = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                    color="success"
                    variant="text"
                    v-if="Permissions.checkPermissions(['claims.reopen'])"
                    :disabled="!data.valid"
                    @click="changeStatus"
                >
                  Confirm
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
        <v-row density="compact">
          <v-col md="6">

            <v-list-item density="compact" v-tooltip:top-start="'A unique UUID for this claim within AAN'">
              <v-list-item-subtitle>AAN Internal Reference Number</v-list-item-subtitle>
              <v-list-item-title>{{data.items.id}}</v-list-item-title>
            </v-list-item>
            <div class="pl-4 pt-2">
              <v-list-item-subtitle>Type</v-list-item-subtitle>
              <v-list-item-title v-for="type in data.items.type" :key="type">{{type}}</v-list-item-title>
            </div>
            <v-list-item density="compact">
                <v-list-item-subtitle>Cat Code</v-list-item-subtitle>
                <v-list-item-title>{{data.items.catcode}}</v-list-item-title>
            </v-list-item>
          </v-col>
          <v-col md="6">
            <v-list-item density="compact">
                <v-list-item-subtitle
                >Policy Number</v-list-item-subtitle
                >
                <v-list-item-title
                >{{data.items.policynumber}}</v-list-item-title
                >
            </v-list-item>
            <v-list-item density="compact">
                <v-list-item-subtitle
                >Loss Amount</v-list-item-subtitle
                >
                <v-list-item-title
                >{{data.items.lossamount}}</v-list-item-title
                >
            </v-list-item>
          </v-col>
          <v-col md="12">
            <v-list-item density="compact">
                <v-list-item-subtitle
                >Loss Address</v-list-item-subtitle
                >
                <v-list-item-title>
                  {{data.items.streetaddress}}
                  <br />
                  {{data.items.city}} {{data.items.state}}
                  <br />
                  {{data.items.zip}}
                </v-list-item-title>
            </v-list-item>
            <v-list-item density="compact">
                <v-list-item-subtitle
                >Date of Loss</v-list-item-subtitle
                >
                <v-list-item-title
                >{{data.items.lossdate}}</v-list-item-title
                >
            </v-list-item>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="py-0">
            <v-list-item density="compact" class="py-0">

                <v-list-item-subtitle class="primary--text">Additional Information:</v-list-item-subtitle>
                <v-list-item-subtitle v-if="data.items.additionalinfo?.length === 0">None</v-list-item-subtitle>
                <h5
                    v-else-if="data.items && typeof data.items.additionalinfo === 'string' && data.items.additionalinfo?.length < 450"
                >
                  {{ data.items.additionalinfo }}
                </h5>
                <h5
                    v-else-if="data.items && typeof data.items.additionalinfo === 'string' && data.items.additionalinfo?.length >= 450 && !data.show"
                    style="height: 55px; overflow: hidden"
                >
                  {{ data.items.additionalinfo }}
                </h5>
                <h5
                    v-else-if="data.items && typeof data.items.additionalinfo === 'string' && data.items.additionalinfo?.length >= 450 && data.show"
                >
                  {{ data.items.additionalinfo }}
                </h5>
                <v-btn
                    v-if="data.items.additionalinfo?.length > 450"
                    @click="data.show = !data.show"
                    size="x-small"
                    variant="elevated"
                >
                  <span v-if="data.show">Hide</span>
                  <span v-else>Show</span>
                  <v-icon>{{ data.show ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                </v-btn>

            </v-list-item>
          </v-col>
        </v-row>
        <v-row v-if="data.items?.s3_key">
          <v-col cols="12" class="py-0 pt-2">
            <v-list-item density="compact" class="py-0">
              <v-btn
                  size="small"
                  variant="elevated"
                  dark
                  color="primary"
                  @click="data.viewRawData = 'open';"
              >View Raw Data
              </v-btn>
            </v-list-item>
          </v-col>
        </v-row>
        <v-row density="compact">
          <v-col class="ma-0">
            <v-card-actions density="compact" class="py-0 px-auto">
              <v-btn
                  size="small"
                  v-if="Permissions.checkPermissions(['claims.update'])"
                  dark
                  color="primary"
                  variant="elevated"
                  @click="data.edit = true; data.newItem = data.items"
              >Edit Claim
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                  class="mx-5"
                  size="small"
                  v-if="Permissions.checkPermissions(['claims.send-acknowledgement']) && (data.ackSent === false)"
                  dark
                  color="primary"
                  variant="elevated"
                  @click="sendEmail()"
              >Send Acknowledgement
              </v-btn>
              <v-btn
                  class="mx-5"
                  size="small"
                  variant="elevated"
                  v-if="(data.ackSent === true)"
                  dark
                  color="primary"
              >Acknowledgement Sent
              </v-btn>
              <span v-if="data.previous" class="px-5">Previous Loss at Location</span>
              <v-checkbox
                  v-if="Permissions.checkPermissions(['claims.set-priority'])"
                  @change="setPriority()"
                  label="High Priority Review"
                  v-model="data.priority"
              >
              </v-checkbox>
            </v-card-actions>
          </v-col>
        </v-row>
      </div>
      <div v-if="data.items.claimstatus === 'Closed'" class="containerClosedBackground">
        CLOSED
      </div>
      <img id="tux"
           crossOrigin="anonymous"
           src="/images/aanew.jpg"
           style="display: none"
           alt=""
      />

      <ClaimRawDataComponent :claimId="props.contextIdA" :status="data.viewRawData" @closed="data.viewRawData='closed'"/>
    </v-card>
  </v-container>
</template>

<style scoped>
  .container {
    padding: 5px;
  }

  [v-cloak] {
    display: none;
  }

  h5 {
    font-weight: normal;
    font-family: sans-serif;
  }

  .v-list-item-subtitle {
    font-size: 10px !important;
    color: black !important;
  }
  .v-list-item-title {
    font-size: 13px !important;
    color: black !important;
  }

  .v-card-subtitle {
    color: black !important;
  }
  .claim__number {
    min-height: 0 !important;
  }
  .v-toolbar-content {
    height: 35px !important;
  }
  .containerForClosedMain {
    position: relative;
  }

  .containerClosedBackground {
    position: absolute;
    font-size: 125px;
    top: 50%;
    left: 50%;
    opacity: .5;
    transform: translate(-50%, -50%) rotate(-25deg);
    color: #FF5252;
  }
</style>